module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="value" contenteditable="' +
__e(isNew ) +
'"></span>\n';
 if (isNew) { ;
__p += '\n    <span class="delete">&#10005;</span>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/components/tag_input/TagView.tpl
// module id = 3055
// module chunks = 0